import React from "react"; // { useContext }
// import { AuthContext } from "../../context/Auth/AuthContext";

import {
  Button,
  Grid,
  Paper,
  TextField,
  ButtonGroup,
  CircularProgress
} from "@material-ui/core";

import moment from "moment";

import Title from "./Title";
import { i18n } from "../../translate/i18n";

const Filters = ({
  classes,
  setDateStartTicket,
  setDateEndTicket,
  dateStartTicket,
  dateEndTicket,
  setQueueTicket,
  queueTicket,
  fetchData,
}) => {
  // const { user } = useContext(AuthContext);

  const [
    queues,
    // setQueues
  ] = React.useState(queueTicket);
  const [dateStart, setDateStart] = React.useState(dateStartTicket);
  const [dateEnd, setDateEnd] = React.useState(dateEndTicket);
  const [fetchDataFilter, setFetchDataFilter] = React.useState(false);
  const [isFiltering, setIsFiltering] = React.useState(false);

  const applyQuickFilter = (days, type) => {
    let start, end;
    const today = moment().format("YYYY-MM-DD");
    if (type === 'mes_atual') {
      start = moment().startOf('month').format("YYYY-MM-DD");
      end = today;
    } else if (type === 'mes_anterior') {
      start = moment().subtract(1, 'month').startOf('month').format("YYYY-MM-DD");
      end = moment().subtract(1, 'month').endOf('month').format("YYYY-MM-DD");
    } else if (type === 'hoje') {
      start = today;
      end = today;
    } else {
      start = moment().subtract(days, 'days').format("YYYY-MM-DD");
      end = today;
    }
    setDateStart(start);
    setDateEnd(end);
  };

  return (
    <Grid item xs={12}>
      <Paper className={classes.customFixedHeightPaperLg} elevation={6}>
        <Title>{i18n.t("dashboard.filters")} </Title>
        <Grid container spacing={3}>
          {/* <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                            <InputLabel id="queue-label">
                                Departamentos
                            </InputLabel>
                            <Select
                                labelId="queue-label"
                                id="queue-select"
                                defaultValue={queueTicket}
                                label="Departamentos"
                                onChange={(e) => setQueues(e.target.value)}
                            >
                                <MenuItem value={false}>
                                    Todos os Departamentos
                                </MenuItem>
                                {user.queues.map((queue) => (
                                    <MenuItem key={queue.id} value={queue.id}>
                                        {queue.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid> */}

          <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
            <ButtonGroup variant="outlined" color="primary" size="small" aria-label="Filtros rápidos">
              <Button onClick={() => applyQuickFilter(0, 'mes_atual')}>Mês Atual</Button>
              <Button onClick={() => applyQuickFilter(0, 'mes_anterior')}>Mês Anterior</Button>
              <Button onClick={() => applyQuickFilter(30, 'dias')}>30 Dias</Button>
              <Button onClick={() => applyQuickFilter(7, 'dias')}>7 Dias</Button>
              <Button onClick={() => applyQuickFilter(0, 'hoje')}>Hoje</Button>
            </ButtonGroup>
          </Grid>

          <Grid item xs={12} sm={6} md={5}>
            <TextField
              fullWidth
              name="dateStart"
              label={i18n.t("dashboard.date.initialDate")}
              InputLabelProps={{
                shrink: true,
              }}
              type="date"
              defaultValue={dateStart}
              onChange={(e) => setDateStart(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <TextField
              fullWidth
              name="dateEnd"
              label={i18n.t("dashboard.date.finalDate")}
              InputLabelProps={{
                shrink: true,
              }}
              type="date"
              defaultValue={dateEnd}
              onChange={(e) => setDateEnd(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={isFiltering}
              onClick={() => {
                setIsFiltering(true);
                setQueueTicket(queues);
                setDateStartTicket(dateStart);
                setDateEndTicket(dateEnd);
                setFetchDataFilter(!fetchDataFilter);
                fetchData(!fetchDataFilter);
                setTimeout(() => setIsFiltering(false), 800); // Feedback visual
              }}
            >
              {isFiltering ? <CircularProgress size={24} color="inherit" /> : <><i className="ri-filter-3-line" style={{ marginRight: 8 }}></i> {i18n.t("dashboard.filter")}</>}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default Filters;
